<template>
  <!-- 修改密码弹窗 -->
  <van-dialog title="请立即修改密码" :value="!$store.state.user.changePwd" :showConfirmButton="false">
    <van-form ref="form" class="pwd-form" @submit="changeSubmit">
      <van-field v-model="user.newPassword" label="新密码" placeholder="请输入新密码" type="password" :rules="[
        {
          required: true,
          message: '新密码不能为空',
          trigger: 'onBlur',
        },
        { min: 6, max: 20, message: '长度在 6 到 20 个字符' },
        { pattern, message: '不能包含非法字符' },
      ]" />
      <van-field v-model="user.confirmPassword" label="确认密码" placeholder="请确认新密码" type="password" :rules="[
        { required: true, message: '新密码不能为空', trigger: 'onBlur' },
      ]" />
      <div class="pwd-tip">密码规则：字母+数字，不能少于6位。</div>
      <div style="margin: 16px">
        <van-button type="info" block native-type="submit">确 定</van-button>
      </div>
    </van-form>
  </van-dialog>
</template>

<script>
import { resetSelfPwd } from '@/api/user'

export default {
  name: "ForceChangePasswordDialog",
  data() {
    return {
      pattern: /^[^<>"'|\\]+$/,
      user: {
        newPassword: undefined,
        confirmPassword: undefined,
      },
    }
  },
  methods: {
    changeSubmit() {
      const regex = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{6,}$/
      if (!regex.test(this.user.newPassword)) {
        return this.$toast('密码必须包含字母、数字并且不能少于6位')
      }
      if (!regex.test(this.user.confirmPassword)) {
        return this.$toast('确认密码必须包含字母、数字并且不能少于6位')
      }
      if (this.user.newPassword == this.user.confirmPassword) {
        resetSelfPwd({ password: this.user.newPassword }).then(() => {
          this.$toast('修改成功')
          this.$store.dispatch('SetChangePwd', true)
          this.$store.dispatch('GetInfo')
          setTimeout(() => {
            this.$router.push({ path: this.redirect || '/' })
          }, 1000)
        })
      } else {
        return this.$toast('确认密码必须和新密码相同')
      }
    },
  }
};
</script>

<style scoped lang="scss">

</style>
